/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { Remarkable } from 'remarkable';
import { linkify } from 'remarkable/linkify';

import css from './remarked.css';

const md = new Remarkable({
  breaks: true,
}).use(linkify);

export default function Remarked({ children, element: Element, ...rest }) {
  if (!children) return null;
  const html = md.render(children.toString());
  return <Element {...rest} css={css} dangerouslySetInnerHTML={{ __html: html }} />;
}

Remarked.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  element: PropTypes.string,
};
Remarked.defaultProps = {
  children: null,
  className: '',
  element: 'div',
};
